export default "__VITE_ASSET__BNU$0nVP__"